import * as React from 'react';
import * as style from './businessUserForgotPassword.module.scss';
import {ForgotPassword} from "src/components/Login/ForgotPassword";
import {PageBase} from "src/components/PageBase/PageBase";

interface BusinessUserRecoveryProps {

}

export const RecoveryPage: React.FC<BusinessUserRecoveryProps> = (props) => {
  return (
    <PageBase showSidebar={false}>
      <ForgotPassword/>
    </PageBase>
  );
};
